import { Graphics } from "pixi.js";

export class FadeScreen extends Graphics {
    public constructor(width: number, height: number, alpha: number, inputBlock: boolean = true) {
        super();
        this.beginFill(0x000000, 1);
        this.drawRect(0, 0, width, height);
        this.endFill();
        this.alpha = alpha;
        this.eventMode = inputBlock ? "static" : "auto";
        this.cursor = "hover";
    }
}
